module.exports = __webpack_public_path__ + "assets/retina_3CirclesIDetailed.b1563ad3efa855d35537c92e40c2f985.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_3CirclesIDetailed.png
// module id = 599
// module chunks = 0